import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value) {
  if (value === null || value === undefined) return '-';
  return '$ ' + new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  
  // Si la fecha viene en formato YYYY-MM-DD, añadir T12:00:00 para evitar problemas de timezone
  let dateStr = dateString;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    dateStr = dateString + 'T12:00:00';
  }
  
  const date = new Date(dateStr);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatNumber(value) {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export const CATEGORIAS = [
  // Fase 0 - Acondicionamiento
  { value: 'limpieza', label: 'Limpieza', fase: '0', icon: 'Broom' },
  { value: 'paja', label: 'Paja (Virutas)', fase: '0', icon: 'Leaf' },
  { value: 'desinfeccion', label: 'Desinfección', fase: '0', icon: 'SprayBottle' },
  { value: 'gas', label: 'Gas', fase: '0', icon: 'Fire' },
  
  // Fase 1 - Recibimiento
  { value: 'pollitos', label: 'Pollitos', fase: '1', icon: 'Bird' },
  
  // Fase 2 - Alimento y Medicamentos
  { value: 'alimento', label: 'Alimento', fase: '2', icon: 'Carrot', hasSubcategoria: true },
  { value: 'medicamentos', label: 'Medicamentos', fase: '2', icon: 'Pill' },
  
  // Fase 3 - Vacunas
  { value: 'vacunas', label: 'Vacunas', fase: '3', icon: 'Syringe' },
  { value: 'mano_obra_vacuna', label: 'Mano de Obra Vacuna', fase: '3', icon: 'Users' },
  
  // Fase 4 - Venta
  { value: 'mano_obra_amarradores', label: 'Mano de Obra Amarradores', fase: '4', icon: 'Users' },
  { value: 'cena_venta', label: 'Cena de Venta', fase: '4', icon: 'ForkKnife' },
  
  // Fase 5 - Gastos Fijos/Financieros
  { value: 'gastos_financieros', label: 'Gastos Financieros', fase: '5', icon: 'Bank' },
  { value: 'nomina', label: 'Nómina', fase: '5', icon: 'Money' },
  { value: 'incentivo', label: 'Incentivo', fase: '5', icon: 'Gift' },
  { value: 'alquiler', label: 'Alquiler', fase: '5', icon: 'Warehouse' },
  { value: 'gasolina', label: 'Gasolina', fase: '5', icon: 'GasPump' },
  { value: 'necropsia', label: 'Necropsia', fase: '5', icon: 'Heartbeat' },
  
  // Fase 6 - Otros
  { value: 'otro', label: 'Otros', fase: '6', icon: 'DotsThree' },
];

export const SUBCATEGORIAS_ALIMENTO = [
  { value: 'pre-inicio', label: 'Pre-Inicio' },
  { value: 'iniciador', label: 'Iniciador' },
  { value: 'crecimiento', label: 'Crecimiento' },
  { value: 'engorde', label: 'Engorde' },
];

export const FASES = [
  { value: '0', label: 'Fase 0 - Acondicionamiento', description: 'Limpieza, Paja, Desinfección, Gas' },
  { value: '1', label: 'Fase 1 - Recibimiento', description: 'Pollitos' },
  { value: '2', label: 'Fase 2 - Alimento y Medicamentos', description: 'Alimento (libras), Medicamentos (unidades)' },
  { value: '3', label: 'Fase 3 - Vacunas', description: 'Vacunas, Mano de obra vacuna' },
  { value: '4', label: 'Fase 4 - Venta', description: 'Mano de obra amarradores, Cena de venta' },
  { value: '5', label: 'Fase 5 - Gastos Fijos', description: 'Financieros, Nómina, Alquiler, Incentivos, Gasolina, Necropsia' },
  { value: '6', label: 'Fase 6 - Otros', description: 'Otros gastos' },
];

export const UNIDADES = [
  { value: 'QQS', label: 'Quintales (QQS)' },
  { value: 'lb', label: 'Libras (lb)' },
  { value: 'kg', label: 'Kilogramos (kg)' },
  { value: 'g', label: 'Gramos (g)' },
  { value: 'ml', label: 'Mililitros (ml)' },
  { value: 'lt', label: 'Litros (lt)' },
  { value: 'galon', label: 'Galones' },
  { value: 'unidad', label: 'Unidades' },
  { value: 'funda', label: 'Fundas' },
  { value: 'dosis', label: 'Dosis' },
  { value: 'hora', label: 'Horas' },
  { value: 'dia', label: 'Días' },
  { value: 'mes', label: 'Meses' },
  { value: 'pago', label: 'Pago' },
  { value: 'servicio', label: 'Servicio' },
];

export function getCategoryColor(categoria) {
  const colors = {
    // Fase 0 - Acondicionamiento
    limpieza: '#00BCD4',      // Cyan
    paja: '#8BC34A',          // Light Green
    desinfeccion: '#9C27B0',  // Purple
    gas: '#FF5722',           // Deep Orange
    // Fase 1 - Alimento y Medicamentos
    pollitos: '#E91E63',      // Pink
    alimento: '#2196F3',      // Blue
    medicamentos: '#F44336',  // Red
    // Fase 2 - Vacunas
    vacunas: '#673AB7',       // Deep Purple
    mano_obra_vacuna: '#009688', // Teal
    // Fase 3 - Venta
    mano_obra_amarradores: '#00ACC1', // Cyan Dark
    cena_venta: '#E91E63',    // Pink
    // Fase 4 - Gastos Fijos
    gastos_financieros: '#607D8B', // Blue Grey
    nomina: '#3F51B5',        // Indigo
    incentivo: '#FF9800',     // Orange
    alquiler: '#795548',      // Brown
    gasolina: '#FFC107',      // Amber
    // Fase 5 - Otros
    otro: '#9E9E9E',          // Grey
  };
  return colors[categoria] || '#9E9E9E';
}

export function getPhaseLabel(fase) {
  const labels = {
    '0': 'Acondicionamiento',
    '1': 'Recibimiento',
    '2': 'Alimento/Medicamentos',
    '3': 'Vacunas',
    '4': 'Venta',
    '5': 'Gastos Fijos',
    '6': 'Otros',
  };
  return labels[fase] || fase;
}

export function getCategoriasByFase(fase) {
  return CATEGORIAS.filter(cat => cat.fase === fase);
}

export function getAlertType(dias) {
  if (dias >= 60) return 'critico';
  if (dias >= 45) return 'advertencia';
  if (dias >= 40) return 'info';
  return 'normal';
}
